import React, { useContext } from 'react';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import EndPoints from '../EndPoints';
import UploadService from '../services/UploadService';
import { CompressionModeContext } from '../context/CompressionModeContextProvider';

const { Dragger } = Upload;

const ImageDragger = props => {
	const { visible } = props;
	const { mode } = useContext(CompressionModeContext);
	return (
		<Dragger
			accept=".png, .jpg, .jpeg"
			multiple
			name="file"
			action={EndPoints.FileCompression}
			onChange={UploadService.onFileChange}
			beforeUpload={UploadService.beforeUpload}
			data={mode}
			showUploadList={false}
			className={visible ? '' : 'hidden'}
		>
			<p className="ant-upload-drag-icon">
				<UploadOutlined />
			</p>
			<p className="ant-upload-text">Drag drop files here OR use the toolbar below to upload</p>
			<p className="dragger-text">
			No limit on number of files. File size limit 20 MB. JPG/JPEG and PNG files allowed.
			</p>
		</Dragger>
	);
};

export default ImageDragger;



// WEBPACK FOOTER //
// ./src/components/ImageDragger.js